import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

// for FriendStats state
function getFriendStatsState(state) {
  return getStateWithOnlyOneLevel(state, 'friendStats');
}

export const getFriendStats = (state) =>
  getFriendStatsState(state).get('friendStatsData');

// for friendActivity

function getFriendActivityState(state) {
  return getStateWithOnlyOneLevel(state, 'friendActivity');
}

export const getFriendActivity = (state) =>
  getFriendActivityState(state).get('friendActivityData');

// for badges state
function getFriendBadgesState(state) {
  return getStateWithOnlyOneLevel(state, 'friendBadges');
}

export const getFriendBadgesSelector = (state) =>
  getFriendBadgesState(state).get('friendBadges');

// for friend Scorign history
function getFriendScoringHistoryState(state) {
  return getStateWithOnlyOneLevel(state, 'friendScoringHistory');
}

export const getFriendScoringHistorySelector = (state) =>
  getFriendScoringHistoryState(state).get('friendScoringHistory');

// for friend Header
function getFriendHeaderState(state) {
  return getStateWithOnlyOneLevel(state, 'friendHeader');
}

export const getFriendHeaderSelector = (state) =>
  getFriendHeaderState(state).get('friendHeader');

// for friend profile

function getFriendProfileState(state) {
  return getStateWithOnlyOneLevel(state, 'friendProfile');
}

export const getFriendProfile = (state) =>
  getFriendProfileState(state).get('friendProfile');
